/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import AdminAction from './AdminAction/index'
import CalendarSettingsAction from './CalendarSettingsAction/index'
import ChairsAction from './ChairsAction/index'
import ChargesAction from './ChargesAction/index'
import CommsAction from './CommsAction/index'
import CommsEmailAction from './CommsEmailAction/index'
import CommsSettingsAction from './CommsSettingsAction/index'
import ConnectAppsAction from './ConnectAppsAction/index'
import ConnectDevelopersAction from './ConnectDevelopersAction/index'
import DevelopmentOnly from 'DesignSystem/DevelopmentOnly/index'
import DocumentTemplatesAction from './DocumentTemplatesAction/index'
import FeatureFlagsAction from './FeatureFlagsAction/index'
import HrAdminAction from './HrAdminAction/index'
import IconsAction from './IconsAction/index'
import LeadsAction from './LeadsAction/index'
import MedicalHistoryAction from './MedicalHistoryAction/index'
import NoteTemplatesAction from './NoteTemplatesAction/index'
import NpsAction from './NpsAction/index'
import OnboardingAction from './OnboardingAction/index'
import PatientHubAction from './PatientHubAction/index'
import PayAppAction from './PayAppAction/index'
import PaymentProviderAction from './PaymentProviderAction/index'
import ProceduresAction from './ProceduresAction/index'
import React from 'react'
import SchedulesAction from './SchedulesAction/index'
import SecureValueAction from './SecureValueAction/index'
import SimpleAction from './SimpleAction/index'
import TracedCephsAction from './TracedCephsAction/index'
import TreatmentAutomationsAction from './TreatmentAutomationsAction/index'
import TreatmentCardAction from './TreatmentCardAction/index'
import TreatmentCaseCloserAction from './TreatmentCaseCloserAction/index'
import TreatmentPaymentsAction from './TreatmentPaymentsAction/index'
import TreatmentPlanTemplatesAction from './TreatmentPlanTemplatesAction/index'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaIconCollapse from 'DesignSystem/Svgs/TysiaIconCollapse/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Menu/Content"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--pl-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-2-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-3-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-4-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bc-5-Z1Yf8zk': dtColorsNeutral100}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 marginLeft={-8}
 type="ghost"
 size="small"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../No'))}
>
{childProps => (
<React.Fragment>
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconCollapse
{...childProps}
  viewPath={`${viewPath}/TysiaIconCollapse`}
/>
)}
</TysiaButtonIcon>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 marginLeft={dtSpaceXs}
 text="Close"
/>
</React.Fragment>
)}
</TysiaButton>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 marginLeft={dtSpaceXxs}
 marginTop={dtSpaceM}
 level="h3"
 text="Outreach"
/>
<NpsAction
  viewPath={`${viewPath}/NpsAction`}
/>
<LeadsAction
  viewPath={`${viewPath}/LeadsAction`}
/>
<PatientHubAction
  viewPath={`${viewPath}/PatientHubAction`}
/>
<PayAppAction
  viewPath={`${viewPath}/PayAppAction`}
/>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 marginLeft={dtSpaceXxs}
 marginTop={dtSpaceM}
 level="h3"
 text="Features"
/>
<TreatmentAutomationsAction
  viewPath={`${viewPath}/TreatmentAutomationsAction`}
/>
<TreatmentCaseCloserAction
  viewPath={`${viewPath}/TreatmentCaseCloserAction`}
/>
<TracedCephsAction
  viewPath={`${viewPath}/TracedCephsAction`}
/>
<MedicalHistoryAction
  viewPath={`${viewPath}/MedicalHistoryAction`}
/>
<TreatmentCardAction
  viewPath={`${viewPath}/TreatmentCardAction`}
/>
<TreatmentPaymentsAction
  viewPath={`${viewPath}/TreatmentPaymentsAction`}
/>
<TreatmentPlanTemplatesAction
  viewPath={`${viewPath}/TreatmentPlanTemplatesAction`}
/>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 marginLeft={dtSpaceXxs}
 marginTop={dtSpaceM}
 level="h3"
 text="Templates"
/>
<DocumentTemplatesAction
  viewPath={`${viewPath}/DocumentTemplatesAction`}
/>
<NoteTemplatesAction
  viewPath={`${viewPath}/NoteTemplatesAction`}
/>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 marginLeft={dtSpaceXxs}
 marginTop={dtSpaceM}
 level="h3"
 text="Scheduling"
/>
<ChairsAction
  viewPath={`${viewPath}/ChairsAction`}
/>
<SchedulesAction
  viewPath={`${viewPath}/SchedulesAction`}
/>
<CalendarSettingsAction
  viewPath={`${viewPath}/CalendarSettingsAction`}
/>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 marginLeft={dtSpaceXxs}
 marginTop={dtSpaceM}
 level="h3"
 text="Comms"
/>
<CommsAction
  viewPath={`${viewPath}/CommsAction`}
/>
<CommsEmailAction
  viewPath={`${viewPath}/CommsEmailAction`}
/>
<CommsSettingsAction
  viewPath={`${viewPath}/CommsSettingsAction`}
/>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 marginLeft={dtSpaceXxs}
 marginTop={dtSpaceM}
 level="h3"
 text="Admin"
/>
<HrAdminAction
  viewPath={`${viewPath}/HrAdminAction`}
/>
<AdminAction
  viewPath={`${viewPath}/AdminAction`}
/>
<PaymentProviderAction
  viewPath={`${viewPath}/PaymentProviderAction`}
/>
<FeatureFlagsAction
  viewPath={`${viewPath}/FeatureFlagsAction`}
/>
<OnboardingAction
  viewPath={`${viewPath}/OnboardingAction`}
/>
<ChargesAction
  viewPath={`${viewPath}/ChargesAction`}
/>
<ProceduresAction
  viewPath={`${viewPath}/ProceduresAction`}
/>
<SecureValueAction
  viewPath={`${viewPath}/SecureValueAction`}
/>
<SimpleAction
  viewPath={`${viewPath}/SimpleAction`}
/>
<DevelopmentOnly
  viewPath={`${viewPath}/DevelopmentOnly`}
>
{childProps => (
<IconsAction
{...childProps}
  viewPath={`${viewPath}/IconsAction`}
/>
)}
</DevelopmentOnly>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 marginLeft={dtSpaceXxs}
 marginTop={dtSpaceM}
 level="h3"
 text="Connect"
/>
<ConnectAppsAction
  viewPath={`${viewPath}/ConnectAppsAction`}
/>
<ConnectDevelopersAction
  viewPath={`${viewPath}/ConnectDevelopersAction`}
/>
</div>
{children}
</React.Fragment>)
}